import React from "react";
import { About } from "./About";

/**
 * Home component that serves as the main landing page of the application.
 * 
 * @returns {JSX.Element} The rendered home page with the About section.
 */
export function Home() {
  return (
    <>
      <div className="full-width-container">
        <About />
      </div>
    </>
  );
}
